/**
  * WBT-Player Debug-Konfiguration
  * @namespace v3sWbtPlayerApp:config
  */

angular.module('v3sWbtPlayerApp').run(["v3sLog", function (v3sLog) {
    v3sLog.setDebugOn(true);
}]);